import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
import IconArrowRight from 'components/icons/iconArrowRight';
import ShowroomLocatorResults from 'components/consumer/consumer-new-footer/components/ShowroomLocatorResults';
import useShowroomLocator from 'hooks/useShowroomLocator';
import useShowroomSearchInput from 'hooks/useShowroomSearchInput';
import CityStateSuggestionsDropdown from 'hooks/useCityStatePlacesAutocomplete/CityStateSuggestionsDropdown';
const MobileNavbarShowroomLocator = t0 => {
  const $ = _c(39);
  const {
    onClose,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "popover" : t1;
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleSearchByPlace,
    handleCloseResults,
    handleViewAll
  } = useShowroomLocator();
  const inputRef = useRef(null);
  const formikRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => {
      formikRef.current?.setFieldValue("zipcode", value);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const handleValueChange = t2;
  let t3;
  if ($[1] !== handleSearch || $[2] !== handleSearchByPlace) {
    t3 = {
      inputRef,
      onValueChange: handleValueChange,
      onSearchByZipcode: handleSearch,
      onSearchByPlace: handleSearchByPlace
    };
    $[1] = handleSearch;
    $[2] = handleSearchByPlace;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    notifyValueChanged,
    validateValue,
    submitValue,
    suggestionsDropdownProps
  } = useShowroomSearchInput(t3);
  const isInMenu = variant === "inMenu";
  const containerClassName = isInMenu ? "w-full px-5 py-3 font-bold [&_a]:!text-brand [&_a]:!underline" : "w-72 px-4 py-3 font-bold [&_a]:!text-brand [&_a]:!underline";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-gray font-bold text-base">Find your closest showroom</div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isInMenu || $[6] !== onClose) {
    t5 = !isInMenu && onClose && <button type="button" onClick={onClose} className="text-gray p-1" aria-label="Close"><IconClose width={12} height={12} /></button>;
    $[5] = isInMenu;
    $[6] = onClose;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="flex justify-between items-center mb-2">{t4}{t5}</div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      zipcode: ""
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== validateValue) {
    t8 = values => {
      const message = validateValue(values.zipcode);
      return message ? {
        zipcode: message
      } : {};
    };
    $[11] = validateValue;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== submitValue) {
    t9 = t10 => {
      const {
        zipcode
      } = t10;
      submitValue(zipcode);
    };
    $[13] = submitValue;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== notifyValueChanged) {
    t10 = t11 => {
      const {
        values: values_0,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit
      } = t11;
      return <form onSubmit={handleSubmit}><div className="flex items-stretch"><input id="mobile-navbar-showroom-zipcode" name="zipcode" type="text" placeholder="Zip Code or City, State" aria-label="Zip code or city and state" value={values_0.zipcode} onChange={event => {
            handleChange(event);
            notifyValueChanged(event.target.value);
          }} onBlur={handleBlur} autoComplete="off" ref={inputRef} className="flex-1 border border-gray-light5 px-3 py-2 text-lg outline-none focus:border-brand" /><button type="submit" className="bg-brand text-white px-3 flex items-center justify-center [&_path]:fill-white" aria-label="Search"><IconArrowRight width={16} height={10} /></button></div>{touched.zipcode && errors.zipcode && <div className="text-red text-xs mt-1">{errors.zipcode}</div>}</form>;
    };
    $[15] = notifyValueChanged;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t8 || $[19] !== t9) {
    t11 = <Formik innerRef={formikRef} initialValues={t7} validate={t8} onSubmit={t9}>{t10}</Formik>;
    $[17] = t10;
    $[18] = t8;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== suggestionsDropdownProps) {
    t12 = suggestionsDropdownProps && <CityStateSuggestionsDropdown {...suggestionsDropdownProps} />;
    $[21] = suggestionsDropdownProps;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== error || $[25] !== handleCloseResults || $[26] !== hasSearched || $[27] !== loading || $[28] !== stores) {
    t14 = hasSearched && <ShowroomLocatorResults loading={loading} error={error} stores={stores} onClose={handleCloseResults} isMobile={true} />;
    $[24] = error;
    $[25] = handleCloseResults;
    $[26] = hasSearched;
    $[27] = loading;
    $[28] = stores;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== handleViewAll) {
    t15 = <div className="mt-3"><Link to="/showrooms/" onClick={handleViewAll} className="text-brand underline text-sm !font-semibold">View All</Link></div>;
    $[30] = handleViewAll;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== containerClassName || $[33] !== t11 || $[34] !== t12 || $[35] !== t14 || $[36] !== t15 || $[37] !== t6) {
    t16 = <div className={containerClassName} data-testid="mobile-hamburger-store-locator">{t6}{t11}{t12}{t13}{t14}{t15}</div>;
    $[32] = containerClassName;
    $[33] = t11;
    $[34] = t12;
    $[35] = t14;
    $[36] = t15;
    $[37] = t6;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  return t16;
};
MobileNavbarShowroomLocator.propTypes = {
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['popover', 'inMenu'])
};
export default MobileNavbarShowroomLocator;